import React, { useState, useRef } from 'react';
import user from '../../../helpers/user';
import { __ } from '../../../translations';
import h from '../../../helpers/common';
import useBraze from '../../../hooks/useBraze';
import { BRAZE } from '../../../config/analytics-events';
import { toast, Button, InputField, Tabs, Text, FlexWrapper } from '@intigral/shared';
import { AlertDialog } from '@intigral/ui/components/AlertDialog';
import { container } from '@intigral/domain/lib/DataDomain';
import { DI } from '@intigral/constant/config/DIContainer';
import {
    qitafVerifyOTPApi,
    qitafGenerateOTPApi,
    resetQitafProperty,
    setQitafProperty,
} from '../../../services/serviceWrapper/qitafServiceWrapper';
import { useConfigurationSections } from '../../../hooks/useConfiguration';

const QitafPopup = ({
    originalPrice,
    updatedPrice = 0,
    productId = null,
    setShowQitafPopup,
    setUpdatedPrice,
    setCurrentComponentType,
    resetQitafProperties = false,
    setQitafApplied,
    content,
}) => {
    const maxQitafAmount = Math.floor(Number(originalPrice));
    const prefilledQitafAmount = originalPrice != null && !Number.isNaN(maxQitafAmount) ? String(maxQitafAmount) : '';

    const [currentStep, setCurrentStep] = useState('msisdn');
    const [isLoading, setIsLoading] = useState(false);
    const [qitafMsisdn, setQitafMsisdn] = useState('');
    const [otp, setOtp] = useState('');
    const [amount, setAmount] = useState(prefilledQitafAmount);
    const [qitafRefId, setQitafRefId] = useState('');
    const { logBrazeCustomEvent } = useBraze();

    const validateButtonRef = useRef();
    const submitButtonRef = useRef();
    const prefixRef = useRef();
    const qitafOTP = useRef();
    const qitafAmount = useRef();
    const isVerifyingRef = useRef(false);
    const OTP_LENGTH = 4;
    const context = h.getAppData();
    // Using React Query instead of Redux for configuration
    const { config } = useConfigurationSections();

    if (resetQitafProperties) {
        resetQitafProperty('qitafPoints');
        resetQitafProperty('qitafRefId');
        resetQitafProperty('qitafMsisdn');
        resetQitafProperty('upadtedPrice');
        setUpdatedPrice(originalPrice);
        setAmount(prefilledQitafAmount);
        setQitafApplied(false);
    }

    /* Start of Maxime Code for Focus  Handling */
    const inputFocus = function (e) {
        var target = e.target;
        if (target.tagName === 'INPUT') {
            target.parentNode.classList.add('focus');
        }
        if (target.tagName === 'TEXTAREA') {
            target.parentNode.classList.add('focus');
        }
    };

    const inputBlur = function (e) {
        var target = e.target;
        if (target.tagName === 'INPUT') {
            target.parentNode.classList.remove('focus');
        }
        if (target.tagName === 'TEXTAREA') {
            target.parentNode.classList.remove('focus');
        }
        if (target.type !== 'checkbox' || target.type !== 'radio') {
            if (target.value && target.value.length > 0) {
                target.parentNode.classList.add('not-empty');
            }
            if (target.value && target.value.length < 1) {
                target.parentNode.classList.remove('not-empty');
            }
        }
    };

    const inputNotEmpty = function (input) {
        if (input.value.length > 0) {
            input.parentNode.classList.add('not-empty');
        }
        if (input.value.length < 1) {
            input.parentNode.classList.remove('not-empty');
        }
    };

    let inputs = [].slice.call(document.querySelectorAll('input[type=text],input[type=email],input[type=password]'));

    inputs.map(function (inputElement) {
        inputNotEmpty(inputElement);
    });
    document.querySelector('body').addEventListener('focusin', inputFocus);
    document.querySelector('body').addEventListener('focusout', inputBlur);
    document.addEventListener('keyup', function (e) {
        var target = e.target;
        if (target.className === 'signup-form__pin') {
            var submitBtn = document.querySelector('#verifypin');
            setTimeout(function () {
                if (target.value && target.value.length >= parseInt(target.getAttribute('maxlength'), 10)) {
                    submitBtn.focus();
                }
            }, 0);
        }
    });
    /* End of Maxime Code for Focus  Handling */

    const updatePhoneNumber = (number) => {
        setQitafMsisdn(number);
    };

    const updateOtp = (otp) => {
        setOtp(otp);
    };

    const updateAmount = (value) => {
        const digits = value.replace(/\D/g, '');
        if (!digits) {
            setAmount('');
            return;
        }
        const num = Number(digits);
        if (num > maxQitafAmount) {
            setAmount(String(maxQitafAmount));
            return;
        }
        setAmount(digits);
    };

    const validateQtiafNumber = () => {
        validateButtonRef.current.classList.add('loading');
        setIsLoading(true);
        const regex = eval(config?.qitaf?.QitafMSISDNRegex);
        if (!qitafMsisdn || (qitafMsisdn && qitafMsisdn.length <= config?.qitaf?.QitafMsisdnMinimumLength)) {
            validateButtonRef.current.classList.remove('loading');
            toast(__('qitaf_validate_msisdn'), 'error');
            setIsLoading(false);
            return false;
        } else if (regex.exec(qitafMsisdn)) {
            validateButtonRef.current.classList.remove('loading');
            otpGenerate();
            return true;
        } else {
            toast(__('qitaf_validate_msisdn'), 'error');
            setIsLoading(false);
            validateButtonRef.current.classList.remove('loading');
            return false;
        }
    };

    const handleQitafErrorMessage = (error) => {
        if (error instanceof Error) {
            toast(__('qitaf_code_9009'), 'error');
        } else if (error && error.code) {
            const translatedMsg = __('qitaf_code_' + error.code);
            if (translatedMsg) {
                toast(translatedMsg, 'error');
            } else if (error.msg) {
                // Show API Error Message if the translation key is not provided
                toast(error.msg, 'error');
            } else {
                //showing general exception only in else case
                toast(__('qitaf_code_9009'), 'error');
            }
        }
    };

    const otpGenerate = async () => {
        validateButtonRef.current.classList.add('loading');
        prefixRef.current.disabled = true;
        validateButtonRef.current.disabled = true;
        let qitafApiParams = {
            productId: productId,
            qitafMsisdn: qitafMsisdn ? config?.qitaf?.QitafMSISDNCountryCode + qitafMsisdn : '',
            uid: user.getUserInfo()?.uid || '',
        };
        try {
            const response = await qitafGenerateOTPApi(qitafApiParams);
            // const response = await apis.getQitafService().generateOTP(qitafApiParams);
            if (response.data) {
                if (response.data.qitafRefId) {
                    setQitafRefId(response.data.qitafRefId);
                }
                toast(
                    __(`qitaf_send_otp_notification` || '')
                        .replace('{COUNTRY_CODE}', config?.qitaf?.QitafMSISDNCountryCode)
                        .replace('{MSISDN}', qitafMsisdn)
                );
                setIsLoading(false);
                validateButtonRef.current.disabled = false;
                prefixRef.current.disabled = false;
                setAmount(prefilledQitafAmount);
                setCurrentStep('otp');
            } else {
                if (validateButtonRef.current) {
                    validateButtonRef.current.disabled = false;
                    prefixRef.current.disabled = false;
                }
                if (validateButtonRef.current) {
                    validateButtonRef.current.disabled = false;
                    prefixRef.current.disabled = false;
                }
                setIsLoading(false);
            }
        } catch (error) {
            if (validateButtonRef.current) {
                setIsLoading(false);
                validateButtonRef.current.disabled = false;
                prefixRef.current.disabled = false;
            }
            if (validateButtonRef.current) {
                validateButtonRef.current.disabled = false;
                prefixRef.current.disabled = false;
            }
        }
    };

    const verifyQtiafNumber = (otpValue) => {
        if (isVerifyingRef.current) return false;

        const otpToVerify = otpValue ?? qitafOTP.current?.value ?? otp;
        if (!otpToVerify) {
            toast(__('qitaf_validate_otp'), 'error');
            return false;
        }
        if (!qitafAmount.current?.value && !amount) {
            toast(__('qitaf_validate_amount'), 'error');
            return false;
        }

        const discountAmount = Number(amount);
        if (!discountAmount || discountAmount <= 0 || discountAmount > maxQitafAmount) {
            toast(__('qitaf_validate_amount'), 'error');
            return false;
        }

        isVerifyingRef.current = true;
        if (submitButtonRef.current) {
            submitButtonRef.current.disabled = true;
        }
        setIsLoading(true);
        otpVerify(otpToVerify);
    };

    const otpVerify = async (otpValue) => {
        let qitafApiParams = {
            productId: productId,
            qitafMsisdn: qitafMsisdn,
            qitafRefId: qitafRefId,
            otp: otpValue ?? otp,
            amount: amount,
            uid: user.getUserInfo()?.uid || '',
        };
        try {
            const response = await qitafVerifyOTPApi(qitafApiParams, config);
            // const response = await apis.getQitafService().verifyOTP(qitafApiParams);
            sessionStorage.setItem('qitafApplied', true);
            if (response?.data) {
                if (response.data.qitafRefId) {
                    setQitafRefId(response.data.qitafRefId);
                }
                setShowQitafPopup(false);
                // document.querySelector('.close-icon').style.display = 'block';
                if (response?.data?.status === 'qitafConsumedSuccessful') {
                    const currentUser = user.getUserInfo();
                    const subscription = await container
                        .resolve(DI.SERVICES.ISubscriptionService)
                        .getSubscriptionStatus(
                            currentUser.apiKey,
                            currentUser.username,
                            currentUser.authToken,
                            currentUser.identityToken
                        );
                    setQitafApplied(true);
                    delete subscription['identityToken'];
                    user.updateUserSubscriptionsObject(subscription, false);
                    setCurrentComponentType('SUCCESS');
                    setIsLoading(false);
                } else {
                    const newPrice = Number(updatedPrice) - Number(amount);
                    setQitafProperty('qitafPoints', amount);
                    setQitafProperty('qitafRefId', response.data.qitafRefId);
                    setQitafProperty('qitafMsisdn', config?.qitaf?.QitafMSISDNCountryCode + qitafMsisdn);
                    setQitafProperty('upadtedPrice', newPrice);
                    setUpdatedPrice(newPrice);
                    setQitafApplied(true);
                    setIsLoading(false);
                }
                logBrazeCustomEvent(BRAZE.EVENTS.TVOD_PURCHASE, {
                    [BRAZE.PROPERTIES.MOVIE_NAME]: content?.textEn ?? '',
                    [BRAZE.PROPERTIES.GENRE]: content?.genre ?? '',
                    [BRAZE.PROPERTIES.LANGUAGE]:
                        (typeof content?.language === 'string' ? content.language : content.language.join(',')) ?? '',
                    [BRAZE.PROPERTIES.PRICE]: originalPrice ?? '',
                });
                    setIsLoading(false);
                    submitButtonRef.current.disabled = false;
            } else {
                isVerifyingRef.current = false;
                try {
                    submitButtonRef.current.disabled = false;
                    setIsLoading(false);
                } catch (e) {
                    submitButtonRef.current.disabled = false;
                    setIsLoading(false);
                }

                handleQitafErrorMessage(response.error);
            }
        } catch (error) {
            isVerifyingRef.current = false;
            try {
                submitButtonRef.current.disabled = false;
            } catch (e) {
                submitButtonRef.current.disabled = false;
            }
            setIsLoading(false);
            handleQitafErrorMessage(error);
        }
    };

    return (
        <>
            <AlertDialog
                open={open}
                acceptButton={(() => {
                    if (currentStep === 'msisdn') {
                        return (
                            <Button
                                id="validate-button"
                                ref={validateButtonRef}
                                onClick={() => validateQtiafNumber()}
                                {...(isLoading && { loading: true })}
                            >
                                {!isLoading && __('qitaf_next')}
                            </Button>
                        );
                    } else if (currentStep === 'otp') {
                        return (
                            <Button
                                id="submit-button"
                                ref={submitButtonRef}
                                onClick={() => verifyQtiafNumber()}
                                {...(isLoading && { loading: true })}
                            >
                                {!isLoading && __('qitaf_submit')}
                            </Button>
                        );
                    }
                    return null;
                })()}
                cancelButton="Cancel"
                iconName={null}
                onCancel={() => {
                    setShowQitafPopup(false);
                }}
                onConfirm={() => {
                    validateQtiafNumber();
                }}
                title={
                    <svg fill="none" height="21" viewBox="0 0 109 21" width="109" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_27365_71958)">
                            <path d="M12.8916 7.44239H15.3244V16.6097H17.2443V5.71165H12.8916V7.44239Z" fill="white" />
                            <path
                                d="M24.1774 13.4918V7.44232H27.9115V5.71163H24.1774V2.05756H22.2575V5.71163H20.1035V7.44232H22.2575V13.7262C22.2575 15.5211 23.3248 16.6096 25.3921 16.6096H27.9724V14.9014H25.4979C24.7287 14.9014 24.1742 14.4744 24.1742 13.4918H24.1774Z"
                                fill="white"
                            />
                            <path d="M17.2441 0.583878H15.3242V3.44806H17.2441V0.583878Z" fill="white" />
                            <path
                                d="M8.72463 7.27218C7.91366 6.09698 6.69892 5.43552 5.09951 5.43552C2.17634 5.43552 0 7.76344 0 11.1606C0 14.5578 2.17634 16.9083 5.0963 16.9083C6.69571 16.9083 7.93294 16.2468 8.72142 15.0716V20.8834H10.5997V5.71166H8.72142V7.27218H8.72463ZM8.72463 12.8721C8.12842 14.2175 7.01941 15.1359 5.37516 15.1359C3.39113 15.1359 1.9616 13.6395 1.9616 11.1606C1.9616 8.68181 3.39113 7.20796 5.37516 7.20796C6.99699 7.20796 8.12521 8.12633 8.72463 9.49419V12.8689V12.8721Z"
                                fill="white"
                            />
                            <path d="M71.8137 0.34317H70.127V2.60689H71.8137V0.34317Z" fill="white" />
                            <path d="M106.559 0.448822H104.937V2.71255H106.559V0.448822Z" fill="white" />
                            <path d="M103.826 0.448822H102.185V2.71255H103.826V0.448822Z" fill="white" />
                            <path
                                d="M43.9586 3.53155V5.71179H41.8271V7.44253H43.9586V16.6098H45.8785V7.44253H49.1863V5.71179H45.8785V3.74668C45.8785 2.72238 46.4747 2.29211 47.3273 2.29211H50.2697V0.583878H47.1991C45.0676 0.583878 43.9554 1.69487 43.9554 3.53155H43.9586Z"
                                fill="white"
                            />
                            <path
                                d="M108.007 5.57698C108.007 5.57698 106.471 4.57195 104.382 4.57195C101.481 4.57195 99.5834 6.45357 99.5834 9.14438C99.5834 11.132 100.715 12.9686 103.423 12.9686C105.045 12.9686 105.856 12.4356 106.324 11.7709V13.1388C106.324 14.3558 105.747 14.6993 104.253 14.6993H98.1154C97.0707 14.6993 96.4102 14.6126 96.1087 14.1021C96.2789 13.5883 96.3651 12.9911 96.3651 12.2847C96.3651 9.22785 94.6599 7.7123 92.2497 7.7123C90.4167 7.7123 88.2622 8.75904 85.9355 9.82832V1.62428H84.2494V14.7025H81.855C79.7847 14.7025 79.2945 14.4874 79.2945 12.6732V1.62428H77.6084V12.6732C77.6084 15.6209 78.6114 16.6902 81.3614 16.6902H91.3301C93.0989 16.6902 94.4226 16.3273 95.2752 15.4732C95.7244 16.263 96.577 16.6902 98.112 16.6902H104.228C107.022 16.6902 108.026 15.4507 108.026 13.0361L108.003 5.58019L108.007 5.57698ZM91.3328 14.7025H85.9355V11.7099C88.6246 10.5572 90.5637 9.69987 92.035 9.69987C93.5064 9.69987 94.6154 10.4898 94.6154 12.3938C94.6154 14.2979 93.57 14.7025 91.3301 14.7025H91.3328ZM106.321 10.1301C105.894 10.6439 105.061 10.9843 103.805 10.9843C102.099 10.9843 101.353 10.0434 101.353 8.90995C101.353 7.56454 102.25 6.58202 104.212 6.58202C105.491 6.58202 106.324 7.09577 106.324 7.09577V10.1301H106.321Z"
                                fill="white"
                            />
                            <path
                                d="M36.3986 5.71165H31.0234V7.44239H36.357C37.2736 7.44239 37.7864 7.95611 37.7864 8.91617V9.75108L33.094 10.4767C31.1517 10.7754 30.001 11.9088 30.001 13.662C30.001 15.6079 31.5139 16.9115 33.7543 16.9115C35.5236 16.9115 36.9755 16.2051 37.7864 14.9882V16.6128H39.684V8.70426C39.684 6.80338 38.5108 5.71165 36.3986 5.71165ZM37.7864 13.0841C37.2736 14.4295 35.78 15.3478 34.1614 15.3478C32.7959 15.3478 31.9434 14.7056 31.9434 13.6588C31.9434 12.6987 32.5844 12.1432 33.7767 11.9506L37.7864 11.2891V13.0841Z"
                                fill="white"
                            />
                            <path
                                d="M71.021 4.57497C68.1202 4.57497 66.2227 6.4566 66.2227 9.14739C66.2227 11.135 67.3541 13.0166 70.0624 13.0166C71.6842 13.0166 72.4951 12.4836 72.9635 11.8189V12.9941C72.9635 14.3395 72.3447 14.7024 70.7455 14.7024H50.3857V16.6899H70.7229C73.6233 16.6899 74.6687 15.4088 74.6687 12.8657L74.6462 5.58C74.6462 5.58 73.1105 4.57497 71.021 4.57497ZM72.9635 10.1524C72.5368 10.7079 71.6842 11.029 70.4474 11.029C68.7422 11.029 67.9952 10.0689 67.9952 8.91295C67.9952 7.56761 68.8926 6.58503 70.8542 6.58503C72.1335 6.58503 72.9662 7.09879 72.9662 7.09879V10.1557L72.9635 10.1524Z"
                                fill="white"
                            />
                        </g>
                        <defs>
                            <clipPath id="clip0_27365_71958">
                                <rect fill="white" height="20.5405" transform="translate(0 0.34317)" width="108.029" />
                            </clipPath>
                        </defs>
                    </svg>
                }
                withFullBleedTitle
            >
                <Tabs
                    tabs={[
                        {
                            content: (
                                <>
                                    <InputField
                                        label={__('qitaf_number_placeholder')}
                                        type="number"
                                        areaCode={`+${config?.qitaf?.QitafMSISDNCountryCode}`}
                                        maxLength={config?.qitaf?.QitafMSISDNLength}
                                        onChange={(event) => {
                                            updatePhoneNumber(event.target.value);
                                        }}
                                        value={qitafMsisdn}
                                        onKeyDown={(e) => {
                                            if (e.key === '.') e.preventDefault();
                                        }}
                                        ref={prefixRef}
                                        dir="auto"
                                        required
                                        name="mobile"
                                    />
                                    <Text alignment="start" as="p" color="gray" variant="text5" margin="0">
                                        {__('qitaf_first_step_description')}
                                    </Text>
                                </>
                            ),
                            title: '',
                        },
                        {
                            content: (
                                <FlexWrapper itemCount="2" gap="2x">
                                    <div>
                                        <InputField
                                            maxLength={OTP_LENGTH}
                                            onChange={(event) => {
                                                const nextOtp = event.target.value.replace(/\D/g, '');
                                                updateOtp(nextOtp);
                                                if (nextOtp.length === OTP_LENGTH) {
                                                    verifyQtiafNumber(nextOtp);
                                                }
                                            }}
                                            ref={qitafOTP}
                                            type="text"
                                            label={__('qitaf_otp_placeholder')}
                                        />
                                        <Text alignment="start" as="p" color="gray" variant="text5" margin="0">
                                            {__('qitaf_otp_description')}S
                                        </Text>
                                    </div>
                                    <div>
                                        <InputField
                                            maxLength={4}
                                            onChange={(e) => updateAmount(e.target.value.replace(/\D/g, ''))}
                                            ref={qitafAmount}
                                            type="text"
                                            label={__('qitaf_amount_placeholder')}
                                            value={amount}
                                        />
                                        <Text alignment="start" as="p" color="gray" variant="text5" margin="0">
                                            {__('qitaf_amount_description')}
                                        </Text>
                                    </div>
                                </FlexWrapper>
                            ),
                            title: '',
                        },
                    ]}
                    value={currentStep === 'msisdn' ? 'tab-0' : 'tab-1'}
                    withDotTriggers
                />
            </AlertDialog>
        </>
    );
};

export default QitafPopup;
